import { parse as _parse, ParsedUrlQuery, stringify as _stringify } from 'querystring';

export const parse = (search: string) => _parse(search.replace(/^\?/, ''));

const clean = (query: ParsedUrlQuery) =>
  Object.keys(query).reduce((a, key) => (query[key]!.length > 0 ? { ...a, [key]: query[key] } : a), {});

export const stringify = (query: ParsedUrlQuery) => `?${_stringify(clean(query))}`;

export const merge = (search: string, query: ParsedUrlQuery) =>
  stringify({
    ...parse(search),
    ...query
  });

export const toArray = (values?: string | string[]) => (values ? (typeof values === 'string' ? [values] : values) : []);
